import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  downloadCouponVoucher,
  fetchCouponDetails,
  fetchCouponList,
} from '../action/couponAction';
import { useUrlSearchParams } from 'use-url-search-params';
import Pagination from '@vlsergey/react-bootstrap-pagination';
import moment from 'moment';
import {
  Col,
  Row,
  Spinner,
  Table,
  Badge,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Dropdown,
  Button,
} from 'reactstrap';
import { Card, Form } from 'react-bootstrap';
import axios from 'axios';
import FilterSearchQueue from '../../../components/FilterSearch/FilterSearchQueue';
import DHPagination from '../../../components/Pagination';

const CouponList = ({ isCouponReload, country, setOpen, setCouponData }) => {
  const dispatch = useDispatch();
  const [btnprimary1, setBtnprimary1] = useState(false);
  const [paginationValue, setPaginationValue] = useUrlSearchParams({ page: 0 });
  const [limitValue, setLimitValue] = useUrlSearchParams({ limit: 10 });
  const [advancedFilter, setAdvancedFilter] = useState({});
  const [searchFilter, setSearchFilter] = useUrlSearchParams({ search: '' });
  const [statusFilter, setStatusFilter] = useUrlSearchParams({ status: 'All' });
  const [isDataLoading, setDataLoading] = useState(false);
  const [copiedId, setCopiedId] = useState(null);
  let currentCountry = localStorage.getItem('WEBSITE_COUNTRY');

  const handleCopyData = (data, id) => {
    navigator.clipboard.writeText(data);
    setCopiedId(id);
  };
  const { couponList = [], isLoading } = useSelector((state) => state?.coupons);

  const fetchCouponData = useCallback(async (data) => {
    try {
      setDataLoading(true);
      await fetchCouponList({
        params: data,
        dispatch,
      }); // send data directly, not { params: data }
    } catch (error) {
      setDataLoading(false);
      console.error('Error fetching orders:', error);
    } finally {
      setDataLoading(false);
    }
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchCouponData({
        start: Number(paginationValue.page * limitValue.limit),
        limit: Number(limitValue.limit),
        sort_by: '',
        order_by: 'id',
        search_qry: searchFilter?.search,
        status: statusFilter?.status,
        advancedFilter,
        country: currentCountry,
        advancedFilter,
      });
    }, 300);
    return () => clearTimeout(delay);
  }, [
    paginationValue.page,
    limitValue,
    advancedFilter,
    searchFilter,
    statusFilter,
    isCouponReload,
  ]);

  const couponData = couponList?.couponList?.data;
  let pageIndex = Number(couponList?.couponList?.start);
  const downloadCoupon = async (id) => {
    try {
      const response = await downloadCouponVoucher({
        params: { promotionId: id },
      });
      const downlaodUrl = `${process.env.REACT_APP_OMS_WEBAPI}v1/promotions/get-coupon?${response?.data}`;
      window.location.href = downlaodUrl;
    } catch (error) {
      console.error('Error downloading PDF:', error);
    }
  };

  return (
    <>
      <Row>
        <Col xl={12}>
          <FilterSearchQueue
            type="coupons"
            setAdvancedFilter={setAdvancedFilter}
            setSearchFilter={setSearchFilter}
            setStatusFilter={setStatusFilter}
          />
          <div className="table-responsive dt-table">
            <Table className="OrderListTable table mb-0">
              <thead>
                <tr>
                  <th>SI.No</th>
                  <th nowrap="nowrap">Date</th>
                  <th>Coupon Info</th>
                  <th>Amount</th>
                  <th>Customer Info</th>
                  <th>Reference No</th>
                  <th>Country</th>
                  <th>Status</th>
                  <th>Created By</th>
                  <th></th>
                </tr>
              </thead>
              {isLoading || isDataLoading ? (
                <>
                  <Spinner className="ms-2 sploader" color="primary" />
                  <tbody>
                    {[...Array(2)].map((_, index) => (
                      <tr>
                        <td>
                          <p className="placeholder-glow">
                            <span className="placeholder col-2"></span>
                          </p>
                        </td>
                        <td>
                          <p className="placeholder-glow">
                            <span
                              className="placeholder"
                              style={{ width: '25%' }}
                            ></span>
                            <span className="placeholder w-75"></span>
                          </p>
                        </td>
                        <td>
                          {' '}
                          <p className="placeholder-glow d-flex flex-column gap-1">
                            <span className="placeholder col-12"></span>
                            <span className="placeholder col-6"></span>
                            <span className="placeholder col-6"></span>
                          </p>
                        </td>
                        <td>
                          {' '}
                          <p className="placeholder-glow">
                            <span className="placeholder col-6"></span>
                          </p>
                        </td>
                        <td>
                          {' '}
                          <p className="placeholder-glow">
                            <span className="placeholder col-6"></span>
                          </p>
                        </td>
                        <td>
                          {' '}
                          <p className="placeholder-glow">
                            <span className="placeholder col-12"></span>
                            <span className="placeholder col-6"></span>
                          </p>
                        </td>
                        <td>
                          <p className="placeholder-glow">
                            <span className="placeholder col-6"></span>
                            <span
                              className="placeholder"
                              style={{ width: '25%' }}
                            ></span>
                          </p>
                        </td>
                        <td>
                          <p className="placeholder-glow">
                            <span className="placeholder col-6"></span>
                            <span
                              className="placeholder"
                              style={{ width: '25%' }}
                            ></span>
                          </p>
                        </td>
                        <td>
                          {' '}
                          <p className="placeholder-glow">
                            <span className="placeholder col-6"></span>
                            <span
                              className="placeholder"
                              style={{ width: '25%' }}
                            ></span>
                          </p>
                        </td>
                        <td></td>
                      </tr>
                    ))}
                  </tbody>
                </>
              ) : couponData?.length > 0 ? (
                <>
                  {(couponData || []).map((coupons, index) => {
                    pageIndex++;
                    let cdate = coupons.createdAt,
                      orderDt = moment(new Date(cdate)).format('Do MMM, YYYY'),
                      orderTime = moment(new Date(cdate)).format('h:mm:ss a');
                    const isExpired = moment(coupons?.validTo).isBefore(
                      moment(),
                      'day',
                    );

                    return (
                      <tbody key={coupons?.id}>
                        <tr>
                          <th scope="row">{pageIndex}</th>
                          <td nowrap="nowrap">
                            {orderDt} <br></br>
                            {orderTime}
                          </td>
                          <td>
                            <span>
                              Code : <b>{coupons?.discountCode}</b>
                            </span>
                            <span
                              style={{ marginLeft: '10px' }}
                              className={`copy-btn ${
                                copiedId === coupons?.id ? 'copied' : ''
                              }`}
                              onClick={() => {
                                handleCopyData(
                                  coupons?.discountCode,
                                  coupons?.id,
                                );
                              }}
                            >
                              <i className="bx bx-copy-alt"></i>{' '}
                              {copiedId === coupons?.id
                                ? 'Copied'
                                : 'Copy'}{' '}
                            </span>
                            <br></br>
                            <span>
                              Validity :{' '}
                              <b>
                                {coupons?.validFrom} To {coupons?.validTo}
                              </b>
                            </span>
                            <br></br>
                            <span>
                              Discount Type : <b>{coupons?.discountType}</b>
                            </span>
                          </td>
                          <td>
                            <span>
                              <b>AED {coupons?.discountAmount}</b>
                            </span>
                          </td>

                          <td nowrap="nowrap">
                            <span>Name : {coupons?.customerName}</span>
                            <br></br>
                            <span>Mobile : {coupons?.mobile}</span>
                            <br></br>
                            <span>Email : {coupons?.email}</span>
                          </td>

                          <td style={{ maxWidth: '200px' }}>
                            <span>{coupons?.orderRef}</span>
                            <br></br>

                            {coupons?.remarks ? (
                              <p>Remarks : {coupons?.remarks}</p>
                            ) : (
                              ''
                            )}
                          </td>
                          <td>{coupons?.country}</td>
                          <td>
                            <Badge
                              className={`${
                                !isExpired ? 'bgSuccess' : 'bgWarning'
                              }`}
                            >
                              {!isExpired ? 'Active' : 'Expired'}
                            </Badge>
                          </td>
                          <td>{coupons?.username}</td>

                          <td>
                            {/* <span>
                              <a
                                className={'link-btn'}
                                href={coupons?.payment_link}
                                target="_blank"
                              >
                                <i className="bx bx-link-external"></i>
                              </a>
                            </span> */}
                            {/* <span className={'expire-txt'}>
                              Expire On : {expiryDt}
                            </span> */}

                            {coupons?.id && !isExpired ? (
                              <Button
                                outline
                                size="sm"
                                color="success"
                                className="waves-effect waves-light"
                                onClick={() => downloadCoupon(coupons?.id)}
                                disabled={isExpired ? true : false}
                              >
                                {/* {returnAWBNo === order?.cst_no ? (
                                  <Spinner
                                    size="sm"
                                    style={{ width: 10, height: 10 }}
                                  />
                                ) : ( */}
                                <i className="bx bx-download"></i>
                                {/* )} */}
                              </Button>
                            ) : null}
                          </td>
                          {/* 
                          <td>
                            <div className="d-flex gap-2 align-items-center">
                              {coupons?.is_done === '0' ? (
                                <span
                                  className="btn btn-sm btn-outline-warning waves-effect waves-light lh-0 py-0 d-flex align-items-center justify-content-center"
                                  style={{ height: '19px' }}
                                  onClick={() =>
                                    getInvoiceData(coupons?.order_reference)
                                  }
                                >
                                  {isCouponLoadingRef ===
                                  coupons?.order_reference ? (
                                    <>
                                      <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        style={{
                                          width: '.75rem',
                                          height: '.75rem',
                                        }}
                                      />
                                    </>
                                  ) : (
                                    <i className="mdi mdi-border-color fs-10"></i>
                                  )}
                                </span>
                              ) : null}
                            </div>
                          </td> */}
                        </tr>
                      </tbody>
                    );
                  })}
                </>
              ) : (
                <>
                  <tbody>
                    <tr>
                      <td colSpan={10}>No Records found</td>
                    </tr>
                  </tbody>
                </>
              )}
            </Table>
          </div>
          {couponData?.length > 0 ? (
            <DHPagination
              totalPages={couponList?.couponList?.recordsTotal}
              currentPage={paginationValue.page}
              setPaginationValue={setPaginationValue}
              setLimitValue={setLimitValue}
            />
          ) : null}
        </Col>
      </Row>
    </>
  );
};

export default CouponList;
